import { useState, useCallback } from 'react';

export interface ChatError {
  id: string;
  type: 'connection' | 'message' | 'session' | 'auth';
  message: string;
  details?: any;
  timestamp: Date;
}

export const useErrorHandler = () => {
  const [errors, setErrors] = useState<ChatError[]>([]);

  const addError = useCallback((type: ChatError['type'], message: string, details?: any) => {
    const error: ChatError = {
      id: `${Date.now()}-${Math.random()}`,
      type,
      message,
      details,
      timestamp: new Date()
    };

    setErrors(prev => [...prev, error]);
    
    // Auto-remove error after 10 seconds
    setTimeout(() => {
      setErrors(prev => prev.filter(e => e.id !== error.id));
    }, 10000);

    return error;
  }, []);

  const removeError = useCallback((errorId: string) => {
    setErrors(prev => prev.filter(e => e.id !== errorId));
  }, []);

  const clearErrors = useCallback(() => {
    setErrors([]);
  }, []);

  const hasErrors = errors.length > 0;
  const latestError = errors[errors.length - 1];

  return {
    errors,
    hasErrors,
    latestError,
    addError,
    removeError,
    clearErrors
  };
};
